import { FULL_TIME, IAM_CONTRACT, TWU_CONTRACT } from "../constants";

export function validateDATWeeksCount(input) {
  if (input === "") {
    return "DAT weeks count is required";
  }

  if (!/^([0-5])$/.test(input)) {
    return "Invalid DAT weeks count"; // Invalid input
  }

  return "";
}

export function validateBlockWeeksCount(input) {
  if (input === "") {
    return "Block weeks count is required";
  }

  if (!/^([0-5])$/.test(input)) {
    return "Invalid Block weeks count"; // Invalid input
  }
  return "";
}

export function validateDatAndBlockWeeksWithTotalBalances(datWeeks, blockWeeks, projectedBalanceWeeks) {
  // Default empty datWeeks and blockWeeks to "0" before parsing
  const blocks = parseInt(blockWeeks, 10);
  const dats = parseInt(datWeeks, 10);

  if (dats + blocks !== projectedBalanceWeeks) {
    return "DAT + Block weeks must equal projected balance";
  }
  return "";
}

export function validateProjectedVacationBalanceCount(contract, ftpt, input) {
  if (input === "") {
    return "Vacation weeks is required";
  }
  if (!/^(0|[1-9]\d*)$/.test(input)) {
    return "Please enter valid Hours"; // Invalid input
  }

  let maxAllowedHours;

  if (contract === IAM_CONTRACT) {
    if (ftpt === FULL_TIME) {
      maxAllowedHours = 200; // Max 5 weeks allowed(5*40)
    } else {
      maxAllowedHours = 150; // Max 5 weeks allowed(5*30)
    }
  } else if (contract === TWU_CONTRACT) {
    maxAllowedHours = 200; //Max 5 weeks allowed(5*40)
  } else {
    return 0;
  }
  const value = Number(input);

  // Ensure value is between 0 and maxAllowedHours (inclusive)
  if (value < 0 || value > maxAllowedHours) {
    return `Must be between 0 and ${maxAllowedHours} for ${ftpt}`;
  }

  return "";
}

export function validateProjectedFTODaysCount(input) {
  if (input === "") {
    return "FTO days count is required";
  }
  if (!/^(0|[1-9]\d*)$/.test(input)) {
    return "Please enter valid Hours"; // Invalid input
  }

  const value = Number(input);

  // Ensure value is between 0 and maxAllowedHours (inclusive)
  if (value < 0 || value > 80) {
    // 80 --> 10 days * 8
    return "Must be between 0 and 80";
  }

  return "";
}
